import { Flex as ChakraFlex, FlexProps } from '@chakra-ui/react'
import { withShade } from './utils'

export const Flex = withShade<FlexProps>(ChakraFlex)
